import { Fieldset } from '@chakra-ui/react';
import React from 'react';

import type { NFTTokenType, TokenType } from 'types/api/token';

import { TOKEN_TYPES, TOKEN_TYPE_IDS, NFT_TOKEN_TYPE_IDS } from 'lib/token/tokenTypes';
import { Checkbox, CheckboxGroup } from 'toolkit/chakra/checkbox';

type Props<T extends TokenType | NFTTokenType> = {
  value: Array<string>;
  setValue: (nextValue: Array<string>) => void;
  onChange: (nextValue: Array<T>) => void;
  defaultValue?: Array<T>;
  nftOnly: boolean;
};
const TokenTypeFilter = <T extends TokenType | NFTTokenType>({ nftOnly, onChange, defaultValue, value, setValue }: Props<T>) => {

  const handleChange = React.useCallback((nextValue: Array<string>) => {
    setValue(nextValue as Array<T>);
    onChange(nextValue as Array<T>);
  }, [ onChange, setValue ]);

  return (
    <Fieldset.Root>
      <CheckboxGroup defaultValue={ defaultValue } onValueChange={ handleChange } value={ value } name="token_type">
        <Fieldset.Content gap={ 7 }>
          { (nftOnly ? NFT_TOKEN_TYPE_IDS : TOKEN_TYPE_IDS).map((id) => (
            <Checkbox key={ id } value={ id }>
              { TOKEN_TYPES[id] }
            </Checkbox>
          )) }
        </Fieldset.Content>
      </CheckboxGroup>
    </Fieldset.Root>
  );
};

export default TokenTypeFilter;
